module.exports = __webpack_public_path__ + "components/weather-icon/static/daycloud@2-c426e8ab7e0ef6e05519e51d5923a026.png";